import { colors } from 'modules/app/styles'
import styled from 'styled-components'

export const ResponseEditor = styled.div`
  margin: 0 auto;
  position: relative;
  z-index: 1;

  .spacer {
    position: relative;
    padding: 0 15px;
    @media (min-width: 576px) {
      padding: 0 26px;
    }
  }

  & .breadcrumb-link:hover{
      color: #0d55ff !important;
    }

  .fadeout-transition {
    transition: background-color 1s ease; /* Transition properties */
  }

  .title {
    font-family: 'PT Serif';
    font-weight: 700;
    font-size: 25px;
    color: ${colors['main-text']};
    border-bottom-color: transparent;
    line-height: 1;
    height: auto;
    padding: 0;
    &::placeholder {
      color: ${colors['main-text']}4d;
    }
    @media (min-width: 576px) {
      font-size: 40px;
      padding-right: 45px;
    }
  }
  width: 100%;
  &:not(.page),
  &:not(.response) {
    max-width: 1100px;
  }
  &.response {
    min-height: calc(100vh - 82px);
    width: 100%;
    @media (min-width: 1200px) {
      width: 800px;
    }
    .content-wrapper {
      position: relative;
      .fr-box {
        flex: 1;
        background: transparent;
      }

      .fr-wrapper {
        background: transparent;
        height: auto !important;
        overflow: auto !important;
      }
    }
  }
  &.page {
    min-height: calc(100vh - 123px);
    width: 100%;
    @media (min-width: 1200px) {
      width: 800px;
    }
    .content-wrapper {
      position: relative;
      .fr-box {
        flex: 1;
        background: transparent;
      }

      .fr-wrapper {
        background: transparent;
        height: auto !important;
        overflow: auto !important;
      }
    }
  }
  &.response {
    .fr-box.fr-basic .fr-element {
      min-height: calc(100vh - 360px);
    }
  }

  &.fr-fullscreen-wrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 15px 15px 0 !important;
    overflow: auto !important;
    z-index: 2 !important;
    margin: 5rem auto 0 auto !important;
    background: white;
    min-width: 100vw !important;
    
    .spacer {
      margin: 0 auto !important;
      width: 100% !important;
      @media (min-width: 1300px) {
        width: 760px !important;
      }
      .fr-fullscreen-wrapper {
        z-index: 2 !important;
      }
      .select-category-dropdown {
        z-index: 3;
      }
    }
    .content-wrapper {
      .fr-box {
        position: relative !important;
        &.fr-fullscreen {
          z-index: 2 !important;
        }
      }
      .insert-button {
        z-index: 6;
      }
    }
  }
`
export const ShortcutBox = styled.div`
  position: absolute;
  height: 187px;
  width: 380px;
  box-shadow: 0px 0px 24px 0px #18181829;
  left: 39px;
  bottom: 62px;
  z-index: 1;
  font-size: 14px;
  background-color: #fff;
  border-radius: 8px 8px 0px 0px;
  padding: 16px;
  display: none;
  &.show {
    display: block;
  }
  @media (max-width: 576px) {
    left: 0;
    width: 100%;
  }
  span.shortcut-box-arrow {
    width: 0;
    display: block;
    height: 0;
    left: calc(50% - 12px);
    border: 12px solid transparent;
    border-bottom: 12px solid #fff;
    position: absolute;
    bottom: -24px;
    z-index: 1;
    transform: rotate(180deg);
  }
  .shortcut-input {
    position: relative;
    .error-icon {
      position: absolute;
      right: 10px;
      top: 10px;
      display: none;
      &.left {
        left: 10px;
        right: auto;
      }
    }
    input {
      margin-top: 4px;
      margin-bottom: 4px;
      height: 37px;
      border: 1px solid ${colors['text-secondary']};
      border-radius: 4px;
      font-size: 14px;
      padding: 8px;
      &:focus {
        border-color: ${colors['main-blue']};
      }
    }
    &.has-error {
      input {
        border-color: ${colors.red};
      }
      .error-icon {
        display: flex;
      }
    }
  }
  .note {
    font-size: 12px;
    color: ${colors['text-secondary']};
    .spchar {
      border: 1px solid ${colors['light-blue-200']};
      color: ${colors.red};
      background: ${colors['light-blue']};
      margin-right: 4px;
      border-radius: 4px;
      display: inline-block;
      width: 16px;
      text-align: center;
      line-height: 1.5;
      font-weight: 600;
    }
  }
  .divider {
    border-top: 1px solid ${colors['light-blue-200']};
    margin: 16px 0;
  }
`
